import { useState } from 'react';
import { Tabs } from 'antd';
import DecisionForm from './decisionForm';
import ReportHistory from './ReportHistory';
import Banner from '../../components/banner';

const ClinicalDecisionAssistantPage = () => {
    const [activeTab, setActiveTab] = useState('new');
    const [selectedReport, setSelectedReport] = useState(null);

    const handleViewReport = (report) => {
        setSelectedReport(report);
        setActiveTab('new');
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
        if (key === 'new') {
            setSelectedReport(null);
        }
    };

    const bannerBackground = "./../../assets/images/banner-bg.png";
    const pageName = "Clinical Decision Assistant";

    return (
        <div className="flex flex-col">
            <Banner backGround={bannerBackground} name={pageName} />
            <main className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
                    <Tabs
                        activeKey={activeTab}
                        onChange={handleTabChange}
                        className="clinical-decision-tabs"
                        tabBarStyle={{ marginBottom: 0 }}
                        items={[
                            {
                                key: 'new',
                                label: 'New Analysis',
                                children: <DecisionForm initialReport={selectedReport} />
                            },
                            {
                                key: 'history',
                                label: 'History',
                                children: <ReportHistory onViewReport={handleViewReport} isActive={activeTab === 'history'} />
                            }
                        ]}
                    />
                </div>
            </main>
        </div>
    );
}

export default ClinicalDecisionAssistantPage